module.exports = __webpack_public_path__ + "img/4c30cd364d805c69067b7e4c5694aa89.536f6f25.jpg";